module.exports = __webpack_public_path__ + "media/assets/images/flags/gm-bae387eccad5225b0829ed996a905ac4.svg";